import React from 'react';
import { CompassIcon, LinkIcon, HeartHandshakeIcon, InstagramIcon } from 'lucide-react';
import { Halo, RuleDot } from './Decor';
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from '../data/site';
const FOUNDER_IMAGE = 'https://cdn.magicpatterns.com/uploads/ur2n2hYoEbvPRyFSQtQeSh/ChatGPT_Image_Jul_30,_2026,_01_29_03_PM.png';
const values = [{
  title: 'Estrategia personalizada',
  body: 'Cada negocio es diferente. Te ayudamos a identificar qué necesitas realmente.',
  icon: <CompassIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-324" data-mp="2xe8y7h7jheui" />
}, {
  title: 'Todo conectado',
  body: 'Estructura, identidad y presencia digital trabajando juntos.',
  icon: <LinkIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-325" data-mp="36enjwhof0vyj" />
}, {
  title: 'Acompañamiento real',
  body: 'Hay una persona detrás de cada proyecto, no solamente una plataforma.',
  icon: <HeartHandshakeIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-326" data-mp="1c0w4t2nbhjvp" />
}];
export function WhyInkova() {
  return <section aria-labelledby="porque-titulo" className="relative overflow-hidden bg-cream" data-id="element-327" data-mp="1ypl138yvw83o">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-8 sm:py-20 lg:py-28" data-id="element-328" data-mp="23oo5cr71iaal">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-20" data-id="element-329" data-mp="28m63dmjir53t">
          {/* Composición de la foto */}
          <div className="relative" data-id="element-330" data-mp="2deqxyqa91m8e">
            <Halo soft className="-left-12 -top-12 h-72 w-72 lg:h-96 lg:w-96" data-id="element-331" data-mp="2hf9n2ckrce6w" />
            <div aria-hidden="true" className="absolute -left-4 -top-4 h-full w-full rounded-xl2 border border-lavender-200 lg:-left-6 lg:-top-6" data-id="element-332" data-mp="2hhduh4hv7vbx" />
            <img src={FOUNDER_IMAGE} alt="Anny, fundadora de Inkova, durante una asesoría con una clienta" loading="lazy" className="relative aspect-[4/3] w-full rounded-xl2 object-cover object-[50%_20%] shadow-lift ring-1 ring-ivory/70 sm:aspect-[4/5] lg:aspect-[3/4]" data-id="element-333" data-mp="2rb4arm3u8zgj" />

            <div className="absolute -bottom-6 left-3 flex max-w-[15rem] items-start gap-3 rounded-2xl border border-lavender-200 bg-ivory/95 p-3.5 shadow-float backdrop-blur-[2px] sm:left-8 lg:-right-10 lg:bottom-12 lg:left-auto" data-id="element-334" data-mp="tx1o7suywtm6">
              <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-pill bg-lavender-50 text-plum-700" data-id="element-335" data-mp="13xc0nb96hx0a">
                <HeartHandshakeIcon className="h-4 w-4" strokeWidth={1.6} aria-hidden="true" data-id="element-336" data-mp="1cwfikbwm06d7" />
              </span>
              <span className="leading-tight" data-id="element-337" data-mp="17xvwmbi0muku">
                <span className="block text-[0.8rem] font-semibold text-plum-900" data-id="element-338" data-mp="17wt45z51ok2t">
                  Acompañamiento real
                </span>
                <span className="mt-1 block text-[0.72rem] text-muted" data-id="element-339" data-mp="1hnfhtnt7b0iv">De persona a persona.</span>
              </span>
            </div>
          </div>

          <div className="mt-8 lg:mt-0" data-id="element-340" data-mp="1vnge0pyitjs0">
            <RuleDot data-id="element-341" data-mp="1rllgzxnmhsk1" />
            <h2 id="porque-titulo" className="mt-5 max-w-xl font-display text-[1.7rem] leading-[1.16] text-plum-900 sm:text-4xl lg:text-[2.6rem]" data-id="element-342" data-mp="1rm4p6mnh12kv">
              No se trata solo de abrir una LLC. Se trata de construir algo bien desde el
              comienzo.
            </h2>

            <dl className="mt-8 space-y-5 sm:mt-11 sm:space-y-7" data-id="element-343" data-mp="2185xa1pl0wwi">
              {values.map(value => <div key={value.title} className="border-t border-lavender-200 pt-4 sm:pt-5" data-id="element-344" data-mp="266h7idjsh9f9">
                  <dt className="flex items-center gap-3" data-id="element-345" data-mp="1rhl0mjtgy2g8">
                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-pill border border-lavender-200 bg-ivory text-plum-700" data-id="element-346" data-mp="1wae4z6l0z8rs">
                      {value.icon}
                    </span>
                    <span className="eyebrow text-plum-700" data-id="element-347" data-mp="1mj9scdito004">{value.title}</span>
                  </dt>
                  <dd className="mt-2.5 max-w-md pl-11 text-[0.975rem] leading-relaxed text-muted sm:mt-3 sm:text-[1rem]" data-id="element-348" data-mp="18k0azaivqzuk">
                    {value.body}
                  </dd>
                </div>)}
            </dl>

            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-analytics-id="instagram_founder" className="mt-6 inline-flex items-center gap-2 text-[0.85rem] text-muted transition-colors duration-200 ease-premium hover:text-plum-800 sm:mt-8" data-id="element-349" data-mp="2fvzp00htjvx1">
              <InstagramIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-350" data-mp="1x61ezeugnsqr" />
              {INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>
      </div>
    </section>;
}